<template lang="pug">
  div
    portal(to="pageTitle")
      span Добавить клуб

    v-container
      Settings(
        :languages="languages"
        :locale="locale"

        @languageChanged="onLanguageChanged"
      )

      .mt-10

      Content(
        :sort="sort"
        :name="name"
        :description="description"
        :image="image"
        @sortChanged="onSortChanged"
        @nameChanged="onNameChanged"
        @descriptionChanged="onDescriptionChanged"
        @imageChanged="onImageChanged"
      )

      .mt-10

      Controls(
        @save="onSave"
      )
</template>

<script>
import Controls from '../../components/widgets/PostControls'
import notify from '../../mixins/notify'

import Settings from './components/Settings'
import Content from './components/Content'
import Mixin from './components/Mixin.js'

import ClubAddGQL from '../../graphql/private/Club/Add.gql'

export default {
  name: 'clubs__add',

  mixins: [Mixin, notify],

  components: {
    Settings,
    Content,
    Controls,
  },

  methods: {
    async onSave() {
      try {
        const res = await this.$apollo.mutate({
          mutation: ClubAddGQL,
          variables: {
            club: {
              active: true,
              locale: this.locale,
              sort: this.sort,
              name: this.name,
              description: this.description,
              image: this.imageFile,
            },
          },
        })

        this.imageFile = null

        this.notify({
          text: 'Достижение обновлено!',
        })

        await this.$router.push({
          name: 'clubs__id',
          params: {
            id: res.data.clubAdd,
          },
        })
      } catch (err) {
        this.notify({
          text: err.message,
          type: 'error',
        })
        throw new Error(err)
      }
    },
  },
}
</script>
